module.exports = __webpack_public_path__ + "img/46.ddc36c81.jpg";